import { SuggestResponseItem } from '@yandex/ymaps3-types';

export const getAddressFromSuggest = (suggestItem: SuggestResponseItem) => {
  if (suggestItem.value) {
    return suggestItem.value;
  }

  const addressValue = suggestItem?.subtitle?.hl
    ? suggestItem?.subtitle.text
    : '';

  return addressValue + suggestItem.title.text;
};
